import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";

const NotFound = () => {
  useSeo({ title: "Page not found", description: "The page you're looking for doesn't exist.", path: "/404" });
  return (
    <div className="mx-auto grid max-w-7xl place-items-center px-4 py-32 text-center sm:px-6 lg:px-8">
      <div>
        <span className="font-mono-ui text-sm text-muted-foreground">404</span>
        <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">Page not found</h1>
        <p className="mt-4 text-muted-foreground">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" data-testid="notfound-home-link" className="mt-8 inline-flex rounded-md bg-foreground px-6 py-3 text-sm font-semibold text-background">
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
